// extracted by mini-css-extract-plugin
export default {"wrapper":"checkbox_wrapper__JelbB","block":"checkbox_block__IRvbu","sm":"checkbox_sm__48gAS","label":"checkbox_label__PT6fN","error":"checkbox_error__CI3UH"};